import React, { useState } from "react";

export const SearchContext = React.createContext();


export const SearchProvider = ({ children }) => {

  const [searchTermDisplay, setSearchTermDisplay] = useState("");
  const [benefitType, setBenefitType] = useState("");
  const [productId, setProductId] = useState("");
  const [productName, setProductName] = useState("");
  const [indicationName, setIndicationName] = useState("");

  return (
    <SearchContext.Provider value={{
        searchTermDisplay, setSearchTermDisplay, 
        benefitType, setBenefitType, 
        productId, setProductId, 
        productName, setProductName, 
        indicationName, setIndicationName
      }}>
    {children}
  </SearchContext.Provider>
  );
};
